export default __webpack_public_path__ + "static/media/background.c660c8b8.png";